import type { AuthPrincipal } from './token-principal'

export const fakeAuthRoleHeader = 'X-Tisit-Fake-Role'
export const fakeAuthRoleStorageKey = 'tisit.fake-auth-role'
export const fakeAuthRoles = [
	'fitness-admin',
	'fitness-admin-viewer',
	'fitness-content-editor',
	'fitness-content-publisher',
	'fitness-media-manager',
] as const

export type FakeAuthRole = (typeof fakeAuthRoles)[number]

export const defaultFakeAuthRole: FakeAuthRole = 'fitness-admin'

export const isFakeAuthRole = (value: unknown): value is FakeAuthRole =>
	typeof value === 'string' && (fakeAuthRoles as readonly string[]).includes(value)

const browserStorage = (): Storage | null =>
	typeof window === 'undefined' ? null : window.localStorage

export const readFakeAuthRole = (storage: Storage | null = browserStorage()): FakeAuthRole => {
	if (!storage) return defaultFakeAuthRole
	try {
		const value = storage.getItem(fakeAuthRoleStorageKey)
		return isFakeAuthRole(value) ? value : defaultFakeAuthRole
	} catch {
		return defaultFakeAuthRole
	}
}

export const createLocalPrincipal = (role: FakeAuthRole = readFakeAuthRole()): AuthPrincipal => ({
	subject: 'local-development',
	username: 'local-development',
	roles: [role],
})
